export default class NewNotificationModel {
  new_notification_count: number;
  constructor() {
    this.new_notification_count = 0;
  }
}
